import FloatMenuCart from 'newComponents/FloatMenuCart'
import { Link } from 'react-router-dom'
import useCartsUser from 'newHooks/useCartsUser'
import { useEffect } from 'react'
import styles from './styles.module.sass'

const GiftsHeaderCart = (props) => {
    const {
        eventId,
        products,
        addProduct,
        deleteProduct,
        setDeleteProduct,
        setListCarts,
        showModule = true
    } = props

    const {
        getListCarts,
        listEvents,
        deleteProducts,
        setAddProducts,
        setProductsList
    } = useCartsUser()


    useEffect(()=>{
        getListCarts(eventId)
    },[])

    useEffect(()=>{
        if(addProduct){
            setAddProducts(addProduct)
        }
    },[addProduct])

    useEffect(()=>{
        if(deleteProduct){
            const {cart_id, productID, variation} = deleteProduct
            deleteProducts(cart_id, productID, variation)
            setDeleteProduct(false)
        }
    },[deleteProduct])

    useEffect(()=>{
        if(listEvents){
            setListCarts(listEvents)
        }
    },[listEvents])

    useEffect(()=>{
        if(products){
            setProductsList(products)
        }else{
            // console.log('no products')
        }
    },[products])

    return(
        showModule
            ?
                <div className={`${styles?.contMenuGifts} containerPortal`}>
                    <div className={styles?.contButtons}>
                        <Link to="/crear-mesa" className="btn btn-primary primaryButton">Crear mesa</Link>
                        <Link to="/faqs" >Preguntas Frecuentes</Link>
                        <Link to="/review" >Reseñas</Link>
                    </div>

                    <FloatMenuCart
                        eventId={eventId}
                        cartId={listEvents[0]?.cart_id}
                        coumtCant={listEvents[0]?.products?.length}
                        products={listEvents[0]?.products}
                        deleteProducts={deleteProducts}
                    />
                </div>
            : null
    )
}

export default GiftsHeaderCart